export const FORM_ADDUSER = {
    username: "",
    password: "",
    confirmPassword: "",
    role: "user"
};
